module.exports = __webpack_public_path__ + "img/slogan-2.54ecd51a.png";